<template>
  <div class="page-content" style="overflow: auto;">
    <h1 class="page-title">{{ $locale("report.memberShipFeeSales") }}</h1>
    <el-row :gutter="10" class="search-area">
      <el-col :span="15">
        <DatePickerGroup
          v-model="filter"
          :showWeekly="true"
        ></DatePickerGroup>
        <el-button
          class="egl-btn-yellow"
          @click="getList"
        >{{ $locale("global.search") }}</el-button>
      </el-col>
      <el-col :span="9" class="ta-r">
          <el-button class="egl-btn-yellow right-align-btn" @click="exportCSV_fn">{{ $locale("global.exportToCSV") }}</el-button>
          <el-button class="egl-btn-yellow" v-print="printObj">{{ $locale("global.printBtn") }}</el-button>
        </el-col>
    </el-row>
    <div id="print">
      <el-row>
        <el-col :span="19">{{ $locale("report.memberShipFeeSales") }}</el-col>
        <el-col :span="5" style="text-align: right;">{{ `${$locale('trans.report.generatedate')}：${exportTime}` }}</el-col>
      </el-row>
      <p>{{ `${$locale('business.date')}：${time}` }}</p>
      <!-- table -->
      <el-row>
        <el-col :span="16" class="custom-border-table film-table memberShip">
          <el-table
            v-if="adminType === 'brand'"
            :data="tableData"
            class="egl-table list-table boxPeriod"
            border
            :span-method="newTableMerge"
            :cell-class-name="totalClassName"
            @sort-change="sortChange_fn"
          >
            <el-table-column
              align="center"
              prop="membershipId"
              :label="$locale('report.memberShip.memberType')"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="windowOnline"
              :label="$locale('report.memberShip.windowOnline')"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="cinemaId"
              :label="$locale('report.memberShip.cinema')"
              :formatter="cinemaNameFormat_fn"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="createUpdate"
              :label="$locale('report.memberShip.createUpdate')"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="price"
              :label="$locale('trans.other.price')"
              :formatter="(row, column, cellValue) => { return cellValue === '-' ? cellValue : '¥' + cellValue.toLocaleString() }"
              sortable="custom"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="visitor"
              :label="$locale('report.onlinebooking.visitor')"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="transactionAmount"
              :label="$locale('report.memberShipFeeSales.transactionAmount')"
              :formatter="(row, column, cellValue) => { return '¥' + cellValue.toLocaleString() }"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="transactionAmountTotal"
              :label="$locale('report.memberShipFeeSales.transactionAmountTotal')"
              :formatter="(row, column, cellValue) => { return '¥' + cellValue.toLocaleString() }"
            ></el-table-column>
          </el-table>
          <el-table
            v-else
            :data="tableDataForCinema"
            class="egl-table list-table boxPeriod"
            border
            :cell-class-name="totalClassNameForCinema"
            @sort-change="sortChange_fn"
            :span-method="newTableMergeForCinema"
          >
            <el-table-column
              align="center"
              prop="membershipId"
              :label="$locale('report.memberShip.memberType')"
              :formatter="(row, column, cellValue) => { return row.type && row.type === 'allTotal' ? cellValue : (memberShipList.find(item => item.id === cellValue) || {}).name }"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="createUpdate"
              :label="$locale('report.memberShip.createUpdate')"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="price"
              :label="$locale('trans.other.price')"
              :formatter="(row, column, cellValue) => { return '¥' + cellValue.toLocaleString() }"
              sortable="custom"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="visitor"
              :label="$locale('report.onlinebooking.visitor')"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="transactionAmount"
              :label="$locale('report.memberShipFeeSales.transactionAmount')"
              :formatter="(row, column, cellValue) => { return '¥' + cellValue.toLocaleString() }"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="transactionAmountTotal"
              :label="$locale('report.memberShipFeeSales.transactionAmountTotal')"
              :formatter="(row, column, cellValue) => { return '¥' + cellValue.toLocaleString() }"
            ></el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import DatePickerGroup from "@/components/common/CommDatePickerGroup/DatePickerGroup.vue";
import { getMemberShipFeeSalesService, getMemberShipOptionListService, getMemberShipFeeSalesForCinemaService } from "@/helpers/service/api/report";
import { getCinemaList } from "@/helpers/service/api/common";
import { exportCSV_fn } from "@/assets/js/memberShipFeeSales_exportCSV";
import { sortMembershipData } from "@/utils/lodashMembershipSort.js";
export default {
  data() {
    return {
      printObj: {
        popTitle: this.$locale("report.memberShip"),
        id: "print",
      },
      adminType: window.localStorage.getItem("adminType"),
      exportTime: 0,
      time: 0,
      filter: {
        startDate: new Date().valueOf(),
        endDate: new Date().valueOf(),
        sort: ""
      },
      cinemaList: [],
      memberShipList: [],
      tableData: [],
      tableDataForCinema: [],
      // 保存原始数据用于还原排序
      originalTableData: [],
      originalTableDataForCinema: [],
      mockCinemaData: {
        data: {
          count: 1,
          data: [
            {
              brandId: "61e528a86814df0a1612d4c5",
              createTime: 1688627598735,
              id: "64a6698e1ad0614219393bf2",
              membership: [
                {
                  membershipId: "6454be578322117ffd51e3f4",
                  offlinePayment: [
                    {
                      cinemaId: "234",
                      newJoinInfo: [],
                      renewInfo: [
                        {
                          amount: 2000,
                          count: 1,
                          totalAmount: 2000
                        }
                      ]
                    }
                  ],
                  onlinePayment: [
                    {
                      cinemaId: "",
                      newJoinInfo: [],
                      renewInfo: [
                        {
                          amount: 1500,
                          count: 2,
                          totalAmount: 3000
                        }
                      ]
                    }
                  ]
                },
                {
                  membershipId: "6454be578322117ffd51e3f4",
                  offlinePayment: [
                    {
                      cinemaId: "234",
                      newJoinInfo: [],
                      renewInfo: [
                        {
                          amount: 4000,
                          count: 4,
                          totalAmount: 6000
                        }
                      ]
                    }
                  ],
                  onlinePayment: [
                    {
                      cinemaId: "",
                      newJoinInfo: [],
                      renewInfo: [
                        {
                          amount: 2500,
                          count: 5,
                          totalAmount: 4500
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ],
          page: 0,
          pageSize: 10
        }
      }
    };
  },
  created() {
    getCinemaList({
      page: 0,
      pageSize: 99999,
    }).then(res => {
      if (res.data && res.data.data.length > 0) {
        this.cinemaList = res.data.data;
      }
    });
    getMemberShipOptionListService({ brandId: window.localStorage.getItem("brandId") }).then(res => {
      this.memberShipList = res.data.map(item => ({
        id: item.id,
        name: item.name
      }));
      if (this.adminType === "brand") {
        getMemberShipFeeSalesService({
          brandId: window.localStorage.getItem("brandId"),
          startTime: this.$moment().startOf("day").valueOf(),
          endTime: this.$moment().add(1, "days").startOf("day").valueOf(),
          ...this.filter.sort ? { sortType:this.filter.sort, sortKey: "amount" } : {},
          page: 0,
          pageSize: 99999
        }).then(res => {
          this.exportTime = this.$moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
          this.time = `${this.$moment(this.filter.startDate).format("YYYY-MM-DD")} 
          ~ ${this.$moment(this.filter.endDate).format("YYYY-MM-DD")}`;
          if (res.data && res.data.data.length > 0) {
            this.tableData = this.formatData_fn(res);
            // 保存原始数据用于还原排序
            this.originalTableData = [ ...this.tableData ];
          }
        });
      } else {
        getMemberShipFeeSalesForCinemaService({
          cinemaId: window.localStorage.getItem("cinemaId"),
          startTime: this.$moment().startOf("day").valueOf(),
          endTime: this.$moment().add(1, "days").startOf("day").valueOf(),
          ...this.filter.sort ? { sortType:this.filter.sort, sortKey: "amount" } : {},
          page: 0,
          pageSize: 99999
        }).then(res => {
          this.exportTime = this.$moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
          this.time = `${this.$moment(this.filter.startDate).format("YYYY-MM-DD")} 
          ~ ${this.$moment(this.filter.endDate).format("YYYY-MM-DD")}`;
          if (res.data && res.data.data.length > 0) {
            this.tableDataForCinema = this.formatData_fn(res);
            // 保存原始数据用于还原排序
            this.originalTableDataForCinema = [ ...this.tableDataForCinema ];
          }
        });
      }

    });
  },
  methods: {
    sortChange_fn({ order }) {
      // 当order为null时，还原到第一次加载的顺序
      if (order === null) {
        if (this.adminType === "brand") {
          this.tableData = [ ...this.originalTableData ];
        } else {
          this.tableDataForCinema = [ ...this.originalTableDataForCinema ];
        }
        return;
      }
      
      // 使用lodash进行分类，根据membershipId，如果membershipId=合計（全て）则不参与分类
      // 根据type=memberTotal的transactionAmountTotal排序
      if (this.adminType === "brand") {
        this.tableData = sortMembershipData(this.tableData, order, this.$_);
      } else {
        // 过滤掉合計（全て）的行，只对会员数据进行排序
        const sortData = this.tableDataForCinema.filter(item => item.type !== "allTotal");
        const allTotalRows = this.tableDataForCinema.filter(item => item.type === "allTotal");
        
        // 按membershipId分组
        const sortGroupData = this.$_.groupBy(sortData, "membershipId");
        
        // 计算每个会员的transactionAmountTotal总和
        const membershipTotalMap = {};
        Object.keys(sortGroupData).forEach(membershipId => {
          const membershipData = sortGroupData[membershipId];
          // 计算该会员所有行的transactionAmountTotal总和
          const total = this.$_.sumBy(membershipData, "transactionAmountTotal");
          membershipTotalMap[membershipId] = total;
        });
        
        // 按transactionAmountTotal排序membershipId
        const sortedMembershipIds = this.$_.orderBy(
          Object.keys(membershipTotalMap),
          [ membershipId => membershipTotalMap[membershipId] ],
          [ order === "ascending" ? "asc" : "desc" ]
        );
        
        // 重新组织数据
        const result = [];
        
        // 按排序后的membershipId顺序添加数据
        sortedMembershipIds.forEach(membershipId => {
          const membershipData = sortGroupData[membershipId];
          result.push(...membershipData);
        });
        
        // 最后添加合計（全て）的行
        result.push(...allTotalRows);
        
        this.tableDataForCinema = result;
      }
    },
    genTwoData_fn(member, platform, type) {
      const _arr = [];
      platform.newJoinInfo.forEach(newItem => {
        _arr.push({
          _membershipId: member.membershipId,
          membershipId: (this.memberShipList.find(item => item.id === member.membershipId) || {}).name,
          windowOnline: type === "window" ? "窓口" : "オンライン",
          cinemaId: platform.cinemaId,
          createUpdate: "新規",
          price: newItem.amount,
          visitor: newItem.count,
          transactionAmount: newItem.totalAmount,
          transactionAmountTotal: this.$_.sumBy(platform.newJoinInfo, "totalAmount") + this.$_.sumBy(platform.renewInfo, "totalAmount")
        });
      });
      platform.renewInfo.forEach(newItem => {
        _arr.push({
          _membershipId: member.membershipId,
          membershipId: (this.memberShipList.find(item => item.id === member.membershipId) || {}).name,
          windowOnline: type === "window" ? "窓口" : "オンライン",
          cinemaId: platform.cinemaId,
          createUpdate: "更新",
          price: newItem.amount,
          visitor: newItem.count,
          transactionAmount: newItem.totalAmount,
          transactionAmountTotal: this.$_.sumBy(platform.newJoinInfo, "totalAmount") + this.$_.sumBy(platform.renewInfo, "totalAmount")
        });
      });
      return _arr;
    },
    genTwoDataTotal_fn(member, platForms) {
      let _arr = [];
      for(let i = 0; i < 2; i++) {
        _arr.push({
          type: "total",
          _membershipId: member.membershipId,
          membershipId: (this.memberShipList.find(item => item.id === member.membershipId) || {}).name,
          windowOnline: `合計（${(this.memberShipList.find(item => item.id === member.membershipId) || {}).name}、窓口）`,
          cinemaId: "",
          createUpdate: i === 0 ? "新規" : "更新",
          price: i === 0 ? this.$_.sumBy(platForms, item => {
            return this.$_.sumBy(item.newJoinInfo, "amount");
          }) : this.$_.sumBy(platForms, item => {
            return this.$_.sumBy(item.renewInfo, "amount");
          }),
          visitor: i === 0 ? this.$_.sumBy(platForms, item => {
            return this.$_.sumBy(item.newJoinInfo, "count");
          }) : this.$_.sumBy(platForms, item => {
            return this.$_.sumBy(item.renewInfo, "count");
          }),
          transactionAmount: i === 0 ? this.$_.sumBy(platForms, item => {
            return this.$_.sumBy(item.newJoinInfo, "totalAmount");
          }) : this.$_.sumBy(platForms, item => {
            return this.$_.sumBy(item.renewInfo, "totalAmount");
          }),
          transactionAmountTotal: this.$_.sumBy(platForms, item => {
            return this.$_.sumBy(item.newJoinInfo, "totalAmount");
          }) + this.$_.sumBy(platForms, item => {
            return this.$_.sumBy(item.renewInfo, "totalAmount");
          })
        });
      }
      return _arr;
    },
    genTwoDataMemberTotal_fn(member, offline, online) {
      let _arr = [];
      let newInfo = (offline[0] || {}).newJoinInfo
      let renewInfo = (offline[0] || {}).renewInfo
      let newPrice = newInfo && newInfo.length > 0 ? newInfo[0].amount : 0
      let renewPrice = renewInfo && renewInfo.length > 0 ? renewInfo[0].amount : 0
      for(let i = 0; i < 2; i++) {
        _arr.push({
          type: "memberTotal",
          _membershipId: member.membershipId,
          membershipId: `合計（${(this.memberShipList.find(item => item.id === member.membershipId) || {}).name}）`,
          windowOnline: "",
          cinemaId: "",
          createUpdate: i === 0 ? "新規" : "更新",
          // price: i === 0 ? this.$_.sumBy(offline, item => {
          //   return this.$_.sumBy(item.newJoinInfo, "amount");
          // }) + this.$_.sumBy(online, item => {
          //   return this.$_.sumBy(item.newJoinInfo, "amount");
          // }) : this.$_.sumBy(offline, item => {
          //   return this.$_.sumBy(item.renewInfo, "amount");
          // }) + this.$_.sumBy(online, item => {
          //   return this.$_.sumBy(item.renewInfo, "amount");
          // }),
          price: i=== 0 ? newPrice : renewPrice,
          visitor: i === 0 ? this.$_.sumBy(offline, item => {
            return this.$_.sumBy(item.newJoinInfo, "count");
          }) + this.$_.sumBy(online, item => {
            return this.$_.sumBy(item.newJoinInfo, "count");
          }) : this.$_.sumBy(offline, item => {
            return this.$_.sumBy(item.renewInfo, "count");
          }) + this.$_.sumBy(online, item => {
            return this.$_.sumBy(item.renewInfo, "count");
          }),
          transactionAmount: i === 0 ? this.$_.sumBy(offline, item => {
            return this.$_.sumBy(item.newJoinInfo, "totalAmount");
          }) + this.$_.sumBy(online, item => {
            return this.$_.sumBy(item.newJoinInfo, "totalAmount");
          }) : this.$_.sumBy(offline, item => {
            return this.$_.sumBy(item.renewInfo, "totalAmount");
          }) + this.$_.sumBy(online, item => {
            return this.$_.sumBy(item.renewInfo, "totalAmount");
          }),
          transactionAmountTotal: this.$_.sumBy(offline, item => {
            return this.$_.sumBy(item.newJoinInfo, "totalAmount");
          }) + this.$_.sumBy(online, item => {
            return this.$_.sumBy(item.newJoinInfo, "totalAmount");
          }) + this.$_.sumBy(offline, item => {
            return this.$_.sumBy(item.renewInfo, "totalAmount");
          }) + this.$_.sumBy(online, item => {
            return this.$_.sumBy(item.renewInfo, "totalAmount");
          })
        });
      }
      return _arr;
    },
    genAllDataTotal_fn(data) {
      let _arr = [];
      let _data = this.$_.cloneDeep(data);
      console.log(_data)
      for(let i = 0; i < 2; i++) {
        _arr.push({
          type: "allTotal",
          membershipId: "合計（全て）",
          windowOnline: "",
          cinemaId: "",
          createUpdate: i === 0 ? "新規" : "更新",
          // personNum: i === 0 ? this.$_.sumBy(_data.filter(item => item.type === 'memberTotal' && item.createUpdate === '新規'), 'personNum') :
          // this.$_.sumBy(_data.filter(item => item.type === 'memberTotal' && item.createUpdate === '更新'), 'personNum'),
          // personNumTotal: i === 0 ? this.$_.sumBy(_data.filter(item => item.type === 'memberTotal' && item.createUpdate === '新規'), 'personNumTotal') :
          // this.$_.sumBy(_data.filter(item => item.type === 'memberTotal' && item.createUpdate === '更新'), 'personNumTotal'),
          // price: i === 0 ? this.$_.sumBy(_data.filter(item => item.type === "memberTotal" && item.createUpdate === "新規"), "price") :
          //   this.$_.sumBy(_data.filter(item => item.type === "memberTotal" && item.createUpdate === "更新"), "price"),
          price: '-',
          visitor: i === 0 ? this.$_.sumBy(_data.filter(item => item.type === "memberTotal" && item.createUpdate === "新規"), "visitor") :
            this.$_.sumBy(_data.filter(item => item.type === "memberTotal" && item.createUpdate === "更新"), "visitor"),
          transactionAmount: i === 0 ? this.$_.sumBy(_data.filter(item => item.type === "memberTotal" && item.createUpdate === "新規"), "transactionAmount") :
            this.$_.sumBy(_data.filter(item => item.type === "memberTotal" && item.createUpdate === "更新"), "transactionAmount"),
          transactionAmountTotal: this.$_.sumBy(_data.filter(item => item.type === "memberTotal" && item.createUpdate === "新規"), "transactionAmount") +
          this.$_.sumBy(_data.filter(item => item.type === "memberTotal" && item.createUpdate === "更新"), "transactionAmount")
        });
      }
      return _arr;
    },
    totalClassName({ row, columnIndex }) {
      if (row.type === "total" && columnIndex === 1) {
        return "total";
      } else if ((row.type === "memberTotal" || row.type === "allTotal") && (columnIndex === 0 || columnIndex === 5 || columnIndex === 6 || columnIndex === 7)) {
        return "memberTotal";
      }
    },
    totalClassNameForCinema({ row, columnIndex }) {
      if (row.type === "total" && (columnIndex === 3 || columnIndex === 4 || columnIndex === 5)) {
        return "total";
      }
    },
    formatData_fn(res) {
      let _arr = [];
      res.data.data.forEach(item => {
        item.membership.forEach(member => {
          member.offlinePayment.forEach(offline => {
            _arr = [..._arr, ...this.genTwoData_fn(member, offline, "window")];
          });
          _arr = [..._arr, ...this.genTwoDataTotal_fn(member, member.offlinePayment)];
          member.onlinePayment.forEach(online => {
            _arr = [..._arr, ...this.genTwoData_fn(member, online, "online")];
          });
          _arr = [..._arr, ...this.genTwoDataMemberTotal_fn(member, member.offlinePayment, member.onlinePayment)];
        });
      });
      _arr = [..._arr, ...this.genAllDataTotal_fn(_arr)];
      return _arr;
    },
    formatDataForCinema_fn(res) {
      let _arr = [];
      res.data.data.forEach(data => {
        data.membership.forEach(member => {
          for(let i = 0; i < 2; i++) {
            _arr.push({
              membershipId: member.membershipId,
              createUpdate: i === 0 ? "新規" : "更新",
              price: i === 0 ? this.$_.sumBy(member.offlinePayment, item => {
                return this.$_.sumBy(item.newJoinInfo, "amount");
              }) + this.$_.sumBy(member.onlinePayment, item => {
                return this.$_.sumBy(item.newJoinInfo, "amount");
              }) : this.$_.sumBy(member.offlinePayment, item => {
                return this.$_.sumBy(item.renewInfo, "amount");
              }) + this.$_.sumBy(member.onlinePayment, item => {
                return this.$_.sumBy(item.renewInfo, "amount");
              }),
              visitor: i === 0 ? this.$_.sumBy(member.offlinePayment, item => {
                return this.$_.sumBy(item.newJoinInfo, "count");
              }) + this.$_.sumBy(member.onlinePayment, item => {
                return this.$_.sumBy(item.newJoinInfo, "count");
              }) : this.$_.sumBy(member.offlinePayment, item => {
                return this.$_.sumBy(item.renewInfo, "count");
              }) + this.$_.sumBy(member.onlinePayment, item => {
                return this.$_.sumBy(item.renewInfo, "count");
              }),
              transactionAmount: i === 0 ? this.$_.sumBy(member.offlinePayment, item => {
                return this.$_.sumBy(item.newJoinInfo, "totalAmount");
              }) + this.$_.sumBy(member.onlinePayment, item => {
                return this.$_.sumBy(item.newJoinInfo, "totalAmount");
              }) : this.$_.sumBy(member.offlinePayment, item => {
                return this.$_.sumBy(item.renewInfo, "totalAmount");
              }) + this.$_.sumBy(member.onlinePayment, item => {
                return this.$_.sumBy(item.renewInfo, "totalAmount");
              }),
              transactionAmountTotal: this.$_.sumBy(member.offlinePayment, item => {
                return this.$_.sumBy(item.newJoinInfo, "totalAmount");
              }) + this.$_.sumBy(member.onlinePayment, item => {
                return this.$_.sumBy(item.newJoinInfo, "totalAmount");
              }) + this.$_.sumBy(member.offlinePayment, item => {
                return this.$_.sumBy(item.renewInfo, "totalAmount");
              }) + this.$_.sumBy(member.onlinePayment, item => {
                return this.$_.sumBy(item.renewInfo, "totalAmount");
              })
            });
          }
        });
      });
      for (let i = 0; i < 2; i++) {
        _arr.push({
          type: "allTotal",
          membershipId: "合計（全て）",
          createUpdate: i === 0 ? "新規" : "更新",
          price: i === 0 ? this.$_.sumBy(_arr.filter(item => item.createUpdate === "新規"), "price") :
            this.$_.sumBy(_arr.filter(item => item.createUpdate === "更新"), "price"),
          visitor: i === 0 ? this.$_.sumBy(_arr.filter(item => item.createUpdate === "新規"), "visitor") :
            this.$_.sumBy(_arr.filter(item => item.createUpdate === "更新"), "visitor"),
          transactionAmount: i === 0 ? this.$_.sumBy(_arr.filter(item => item.createUpdate === "新規"), "transactionAmount") :
            this.$_.sumBy(_arr.filter(item => item.createUpdate === "更新"), "transactionAmount"),
          transactionAmountTotal: this.$_.sumBy(_arr.filter(item => item.type !== "allTotal"), "transactionAmount")
        });
      }
      return _arr;
    },
    cinemaNameFormat_fn(row, column, cellValue) {
      if (!cellValue) {
        return "ー";
      }
      return (this.cinemaList.find(item => item.id === cellValue) || {}).name;
    },
    getList() {
      if (this.adminType === "brand") {
        getMemberShipFeeSalesService({
          startTime: this.$moment(this.filter.startDate).startOf("day").valueOf(),
          endTime: this.$moment(this.filter.endDate).add(1, "days").startOf("day").valueOf(),
          ...this.filter.sort ? { sortType:this.filter.sort, sortKey: "amount" } : {},
          brandId: window.localStorage.getItem("brandId"),
          page: 0,
          pageSize: 99999
        }).then(res => {
          this.tableData = [];
          this.exportTime = this.$moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
          this.time = `${this.$moment(this.filter.startDate).format("YYYY-MM-DD")} 
            ~ ${this.$moment(this.filter.endDate).format("YYYY-MM-DD")}`;
          if (res.data && res.data.data.length > 0) {
            this.tableData = this.formatData_fn(res);
            // 保存原始数据用于还原排序
            this.originalTableData = [ ...this.tableData ];
          }
        });
      } else {
        getMemberShipFeeSalesForCinemaService({
          startTime: this.$moment(this.filter.startDate).startOf("day").valueOf(),
          endTime: this.$moment(this.filter.endDate).add(1, "days").startOf("day").valueOf(),
          ...this.filter.sort ? { sortType:this.filter.sort, sortKey: "amount" } : {},
          cinemaId: window.localStorage.getItem("cinemaId"),
          page: 0,
          pageSize: 99999
        }).then(res => {
          this.tableDataForCinema = [];
          this.exportTime = this.$moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
          this.time = `${this.$moment(this.filter.startDate).format("YYYY-MM-DD")} 
            ~ ${this.$moment(this.filter.endDate).format("YYYY-MM-DD")}`;
          if (res.data && res.data.data.length > 0) {
            this.tableDataForCinema = this.formatDataForCinema_fn(res);
            // 保存原始数据用于还原排序
            this.originalTableDataForCinema = [ ...this.tableDataForCinema ];
          }
        });
      }
    },
    exportCSV_fn() {
      const _data = this.adminType === "brand" ? this.tableData : this.tableDataForCinema;
      exportCSV_fn(_data, this.memberShipList, this.cinemaList, this.adminType);
      // if (this.adminType === "brand") {
      //   getMemberShipFeeSalesService({
      //     brandId: window.localStorage.getItem("brandId"),
      //     startTime: this.$moment(this.filter.startDate).startOf("day").valueOf(),
      //     endTime: this.$moment(this.filter.endDate).add(1, "days").startOf("day").valueOf(),
      //     ...this.filter.sort ? { sortType:this.filter.sort, sortKey: "amount" } : {},
      //     page: 0,
      //     pageSize: 99999
      //   }).then(res => {
      //     if (res.data && res.data.data.length > 0) {
      //       const _arr = this.formatData_fn(res);
      //       exportCSV_fn(_arr, this.memberShipList, this.cinemaList);
      //     }
      //   });
      // } else {
      //   getMemberShipFeeSalesForCinemaService({
      //     startTime: this.filter.startDate,
      //     endTime: this.filter.endDate,
      //     ...this.filter.sort ? { sortType:this.filter.sort, sortKey: "amount" } : {},
      //     cinemaId: window.localStorage.getItem("cinemaId"),
      //     page: 0,
      //     pageSize: 99999
      //   }).then(res => {
      //     if (res.data && res.data.data.length > 0) {
      //       const _arr = this.formatDataForCinema_fn(res);
      //       exportCSV_fn(_arr, this.memberShipList, this.cinemaList, this.adminType);
      //     }
      //   });
      // }
    },
    getCount(model, key) {
      let spanArr = [];
      let pos = 0;
      const validArrs = ["personNumTotal", "cinemaId", "transactionAmountTotal"];
      for (let i = 0; i < model.length; i++) {
        if (i === 0) {
          spanArr.push(1);
          pos = 0;
        } else if (key === "personNumTotal" && model[i][key] === model[i - 1][key] &&
        model[i].windowOnline === model[i - 1].windowOnline && model[i].cinemaId === model[i - 1].cinemaId) {
          spanArr[pos] += 1;
          spanArr.push(0);
        } else if (key === "cinemaId" && model[i][key] === model[i - 1][key] &&
        model[i].windowOnline === model[i - 1].windowOnline)  {
          spanArr[pos] += 1;
          spanArr.push(0);
        } else if (key === "transactionAmountTotal" && model[i][key] === model[i - 1][key] &&
        model[i].cinemaId === model[i - 1].cinemaId && model[i].type === model[i - 1].type) {
          spanArr[pos] += 1;
          spanArr.push(0);
        } else if (!validArrs.includes(key) && model[i][key] === model[i - 1][key]) {
          spanArr[pos] += 1;
          spanArr.push(0);
        } else {
          spanArr.push(1);
          pos = i;
        }
      }
      return spanArr;
    },
    getTotalMerge(columnIndex, type) {
      if (type && (type === "total")) {
        if (columnIndex === 1) {
          return 2;
        } else if (columnIndex === 2) {
          return 0;
        }
        return 1;

      } else if (type && (type === "memberTotal" || type === "allTotal")) {
        if (columnIndex === 0) {
          return 3;
        } else if (columnIndex > 0 && columnIndex < 3) {
          return 0;
        }
        return 1;

      }
      return 1;
    },
    mergeComon(key, rowIndex, columnIndex) {
      const _row = this.getCount(this.tableData, key)[rowIndex];
      return {
        rowspan: _row,
        colspan: this.getTotalMerge(columnIndex, this.tableData[rowIndex].type)
      };
    },
    mergeComonForCinema(key, rowIndex) {
      const _row = this.getCount(this.tableDataForCinema, key)[rowIndex];
      const _col = _row > 0 ? 1 : 0;
      return {
        rowspan: _row,
        colspan: _col
      };
    },
    newTableMerge({ rowIndex, columnIndex }) {
      switch(columnIndex) {
      case 0:
        return this.mergeComon("membershipId", rowIndex, columnIndex);
      case 1:
        return this.mergeComon("windowOnline", rowIndex, columnIndex);
      case 2:
        return this.mergeComon("cinemaId", rowIndex, columnIndex);
      case 7:
        return this.mergeComon("transactionAmountTotal", rowIndex, columnIndex);
      default:
        break;
      }
    },
    newTableMergeForCinema({ rowIndex, columnIndex }) {
      switch(columnIndex) {
      case 0:
        return this.mergeComonForCinema("membershipId", rowIndex, columnIndex);
      case 5:
        return this.mergeComonForCinema("transactionAmountTotal", rowIndex, columnIndex);
      default:
        break;
      }
    }
  },
  components: {
    DatePickerGroup
  },
};
</script>
<style lang="less" scoped>
  .memberShip::v-deep {
    .total, .memberTotal {
      font-weight: 600;
      color: #181818;
    }
  }
</style>